import React from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import PredefinedRangesDropdown from './PredefinedRangesDropdown';

import { maxDate } from '../configs';
import { initialFrom, initialTo } from '../configs/date-range-picker';
import { format, yesterday, differenceInDays, isBefore } from '../../../utils/date';

const PredefinedRangesDropdownWrapper = ({
  dateFrom,
  dateTo,
  currentPeriod,
  maxDateTo,
  maxPeriod,
  maxShowedPeriod,
  minSelectablePeriod,
  dataStartDate,
  limitedPeriodText,
  disabled,
  onChange,
}) => {
  const decoratedMaxDate = maxDate(maxDateTo);

  const from = initialFrom(dateFrom, currentPeriod, decoratedMaxDate);
  const to = initialTo(dateTo, decoratedMaxDate);

  const handleRangeSubmit = ({ period, date_from, date_to }) => {
    const changes = {
      period,
      period_from_date: date_from,
      period_to_date: date_to,
    };

    if (isEmpty(date_to)) {
      changes.period_to_date = format(decoratedMaxDate);
    }

    onChange(changes);
  };

  return (
    <PredefinedRangesDropdown
      maxPeriod={maxPeriod}
      customTo={to && format(to)}
      customFrom={from && format(from)}
      maxShowedPeriod={maxShowedPeriod || differenceInDays(yesterday(), HISTORICAL_START_DATE) + 1}
      minSelectablePeriod={minSelectablePeriod}
      disabled={disabled || isBefore(decoratedMaxDate, yesterday())}
      dataStartDate={dataStartDate}
      limitedPeriodText={limitedPeriodText}
      onChange={handleRangeSubmit}
    />
  );
};

PredefinedRangesDropdownWrapper.propTypes = {
  dateFrom: T.string,
  dateTo: T.string,
  currentPeriod: T.number.isRequired,
  maxDateTo: T.instanceOf(Date),
  maxPeriod: T.number.isRequired,
  maxShowedPeriod: T.number,
  minSelectablePeriod: T.number,
  dataStartDate: T.string,
  limitedPeriodText: T.string,
  disabled: T.bool,
  onChange: T.func.isRequired,
};

export default PredefinedRangesDropdownWrapper;
